import type {LocationSuggestion} from "@/api/apiClient";

const ADDRESS_MAPPINGS: Record<string, string> = {
    "letiště václava havla praha": "Vaclav Havel Airport Prague, Ruzyně",
    "praha hlavní nádraží": "Main Railway Station Prague, Wilsonova",
    "zoo praha": "Zoo Prague, U Trojského zámku",
};

function updateLocationSuggestionAddress(s: LocationSuggestion) {
    // FIXME: this is a hack, should be handled on backend
    // same object just swap address in some cases
    const mappedAddress = ADDRESS_MAPPINGS[s.location.address.toLowerCase()];
    if (mappedAddress) {
        return {
            ...s,
            location: {
                ...s.location,
                address: mappedAddress,
            },
        };
    }
    return s;
}

export function getFormattedPredefinedSuggestions(suggestions: LocationSuggestion[]) {
    if (suggestions.some((s) => s.type === "PREDEFINED_PLACE")) {
        return suggestions
            .filter((s) => s.type === "PREDEFINED_PLACE")
            .map(updateLocationSuggestionAddress);
    }
    return suggestions.filter((s) => s.type === "POI").map(updateLocationSuggestionAddress);
}

export function transformAddressType(type: "dropoff" | "pickup") {
    switch (type) {
        case "dropoff":
            return "DESTINATION";
        case "pickup":
            return "PICKUP";
        default:
            return type satisfies never;
    }
}
